import React, { Component } from 'react'
import styled from 'styled-components'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Modal, Button, Colors, Table, TableCell, TableHeader, TableLoading,
  TableExpander, TextIcon, Pagination, RoundedTabs } from 'advenio-components'
import { connect } from 'react-redux'
import ValidatedReceiptsActions, { getValidateReceipts } from '../../Data/Redux/ValidatedReceiptsRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CountriesActions from '../../Data/Redux/CountriesRedux'
import StudentReceiptDetail from './StudentReceiptDetail'

const ReceiptId = styled.span`
  color: ${Colors.red500};
`
const TableContainer = styled.div`
  .rt-tr-group{
    .invalid-receipt-btn{
      display: none;
      margin: 0 auto;
      padding: 5px;
      font-size: 14px;
    }

    &:hover{
      .valid-receipt-text{
        display: none;
      }

      .invalid-receipt-btn{
        display: block;
      }
    }
  }
`
const InfoCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const StudentName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.blue500};
  cursor: pointer;
`
const ParentName = styled.span`
  margin-left: 4px;
  color: ${Colors.gray800}
`
const Container = styled.div`
  padding: 32px;
`
const ValidatedReceiptsText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const HeaderContainer = styled.div`
  width: 100%;
  height: 60px;
  margin-bottom: 30px;
  display: flex;
  font-size: 30px;
  font-weight: bold;
  flex-direction: row;
  align-items: center;

  span {
    margin-right: 10px;
  }
`
const UnactivateReceiptMsg = styled.div`
  padding: 0 15px 15px;

  .footer{
    text-align: center;
    padding-top: 16px;
  }
`

class ValidatedReceipts extends Component {
  state = {
    expanded: [],
    firstPageToRender: 1,
    lastPageToRender: 10,
    pageSelected: 1,
    queryParams: {},
    isMexican: false,
    receiptToInvalidate: null,
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)

    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }

    this.setState({ queryParams })
    // Send API request with query param: without_retention in order to return original totals
    this.props.getReceipts({ without_retention: true, ...queryParams })
    // this.props.getClassrooms()
    this.props.getCountries()
  }

  componentWillReceiveProps = (nextProps) => {
    const { countries, user } = nextProps

    if (countries && user) {
      const country = countries.find(c => c.id === user.country_id)
      if (country && country.name === 'Mexico') {
        this.setState({ isMexican: true })
      }
    }
  }

  onClickPage = (pageSelected) => {
    this.setState({ pageSelected }, () => {
      const queries = { ...this.state.queryParams, page: pageSelected }

      this.props.getReceipts(queries)
      this.props.goTo(`?${queryString.stringify(queries)}`)
    })
  }

  setIdReceiptToInvalidate = (id = null) => this.setState({ receiptToInvalidate: id })

  toggleViewReceiptDetail = (index) => {
    const newState = { ...this.state }

    newState.expanded[index] = !newState.expanded[index]

    this.setState(newState)
  }

  goTo = e => this.props.goTo(e.currentTarget.id)

  navigateToProfile = (student) => {
    const { classroom_id: classroomId, id: studentId } = student

    return this.props.goTo(`/classroom/${classroomId}/student/${studentId}`)
  }

  invalidateReceipt = () => {
    this.props.unvalidateReceipt(this.state.receiptToInvalidate)
    this.setIdReceiptToInvalidate()
  } 
  getButtonInvalid = (user,id) => {
    if(user.role === 'Back Office Admin'){
      return (
          <Button className="invalid-receipt-btn" danger onClick={() => this.setIdReceiptToInvalidate(id)} small>
              <TextIcon flex flexCenter label="Invalidar" iconType="close" iconColor="" />
          </Button>
      );
     }
  }

  render() {
    const {
      loading,
      meta,
      receipts,
      user
    } = this.props
    const {
      expanded,
      pageSelected,
    } = this.state

    return (
      <Container>
        <HeaderContainer>
          <span>
            Validación de recibos
          </span>
          <RoundedTabs
            selectedTab={'/validated-receipts'}
            tabs={[
              {
                id: '/unvalidated-receipts',
                title: 'Por validar',
              },
              {
                id: '/validated-receipts',
                title: 'Validados',
              },
            ]}
            onClick={this.goTo}
          />
        </HeaderContainer>
        <TableContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {loading ?
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Fecha de Validación',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 2,
                  header: '# de Recibo',
                  element: 'Text',
                  center: false,
                },
                {
                  id: 3,
                  header: 'Alumno',
                  element: 'Text',
                  center: false,
                },
                {
                  id: 4,
                  header: 'Monto',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: '',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={10}
            />
            :
            <Table
              roundedCorners
              SubComponent={HOC(StudentReceiptDetail)}
              data={receipts}
              expanded={expanded}
              columns={[
                {
                  id: 1,
                  expander: true,
                  Header: () => <TableHeader blue />,
                  Expander: ({ isExpanded, ...rest }) => (
                    <TableCell>
                      <TableExpander
                        id={rest.index}
                        open={isExpanded}
                        openCard={() => this.toggleViewReceiptDetail(rest.index)}
                      />
                    </TableCell>
                  ),
                },
                {
                  id: 2,
                  Header: () => <TableHeader title="Fecha de Validación" blue />,
                  Cell: ({ original: { validated_at } }) =>
                    <TableCell>{moment(validated_at).format('YYYY-MM-DD HH:mm')}</TableCell>,
                  maxWidth: 200,
                },
                {
                  id: 3,
                  Header: () => <TableHeader title="# de Recibo" blue />,
                  Cell: ({ original: { id } }) =>
                    <TableCell ><ReceiptId>{id}</ReceiptId></TableCell>,
                  maxWidth: 200,
                },
                {
                  id: 4,
                  Header: () => <TableHeader title="Alumno" blue />,
                  Cell: ({ original: { student, parent } }) => (
                    <TableCell >
                      <InfoCell>
                        <InfoRow>
                          <StudentName onClick={() => this.navigateToProfile(student)}>
                            {student && student.name}
                          </StudentName>
                        </InfoRow>
                        <InfoRow>
                          Tutor: <ParentName>{parent && parent.name}</ParentName>
                        </InfoRow>
                      </InfoCell>
                    </TableCell>
                  ),
                },
                {
                  id: 5,
                  Header: () => <TableHeader title="Monto" blue center />,
                  Cell: ({ original: { total_formatted } }) =>
                    <TableCell center>{total_formatted}</TableCell>,
                  maxWidth: 200,
                },
                {
                  id: 6,
                  Header: () => <TableHeader blue />,
                  maxWidth: 200,
                  Cell: ({ original: { id } }) => (
                    <TableCell center>
                      <ValidatedReceiptsText
                        label="Validado"
                        iconType="checkmark"
                        iconViewBox="0 1 18 18"
                        iconColor={Colors.green500}
                        className={user.role === 'Back Office Admin'?"valid-receipt-text":null}
                      />
                     {this.getButtonInvalid(user,id)}
                    </TableCell>
                  ),
                },
              ]}
            />
          }
        </TableContainer>
        <Modal
          isOpened={this.state.receiptToInvalidate !== null}
          onClose={this.setIdReceiptToInvalidate}
          headerTitle="¿Invalidar recibo?"
          id="modal-invalidate-receipt"
          smallHeader
        >
          <UnactivateReceiptMsg>
            <p>¿Estas seguro de invalidar el recibo con número:
              <strong> {this.state.receiptToInvalidate}</strong>?</p>
            <div className="footer">
              <Button onClick={() => this.setIdReceiptToInvalidate()} small>Cancelar</Button>
              <Button onClick={() => this.invalidateReceipt()} primary small>Invalidar</Button>
            </div>
          </UnactivateReceiptMsg>
        </Modal>
      </Container>
    )
  }
}

ValidatedReceipts.propTypes = {
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** The listing of unvalidated receipts */
  receipts: PropTypes.array,
  /** Meta data for the paginated results */
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** React router location information, containing query params etc. */
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** The currently authenticated user */
  user: PropTypes.object.isRequired,

  /** Fetch a listing of all classrooms in this center */
  getClassrooms: PropTypes.func.isRequired,
  /** Fetch a listing of all available countries */
  getCountries: PropTypes.func.isRequired,
  /** Fetch the listing of unvalidated receipts from the API */
  getReceipts: PropTypes.func.isRequired,
  /** Navigate to the given URI */
  goTo: PropTypes.func.isRequired,
  /** Submit a request to the API to mark a given receipt as unvalidated */
  unvalidateReceipt: PropTypes.func.isRequired,
}

ValidatedReceipts.defaultProps = {
  meta: () => {},
  location: {},
  receipts: [],
}

const mapStateToProps = ({
  validatedReceipts,
  countries,
  auth,
}) => ({
  receipts: getValidateReceipts(validatedReceipts.get.results.data),
  meta: validatedReceipts.get.results.meta,
  loading: validatedReceipts.get.fetching,
  user: auth.user,
  countries: countries.get.results,
})

const mapDispatchToProps = dispatch => ({
  getReceipts: query => dispatch(ValidatedReceiptsActions.getRequest(query)),
  getClassrooms: () => dispatch(ClassroomActions.getRequest()),
  goTo: path => dispatch(push(path)),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  unvalidateReceipt: id => dispatch(ValidatedReceiptsActions.unvalidateRequest(id, {})),
})

const HOC = SubComponent => props => <SubComponent {...props} />

export default connect(mapStateToProps, mapDispatchToProps)(ValidatedReceipts)



// WEBPACK FOOTER //
// ./src/Containers/ReceiptValidations/ValidatedReceipts.jsx